import { findEntryPointQuery } from "../graphql/documentUtils/entrypoint";
/**
 * Extracts top-level field aliases and names from a graphql operation.
 * @param {DocumentNode} document - The GraphQL document
 * @returns {FieldNameData[]} - Array of top-level field aliases and names
 */ export function extractTopLevelFieldNameData(document) {
    const topLevelFields = [];
    // [1] Find the document definition
    const queryDefinition = findEntryPointQuery(document);
    // [2] Extract aliases and field names from the selections
    queryDefinition.selectionSet.selections.forEach((selection)=>{
        // [2.1] Handle top level fields
        if (selection.kind === 'Field') {
            var _selection_alias;
            topLevelFields.push({
                alias: (_selection_alias = selection.alias) === null || _selection_alias === void 0 ? void 0 : _selection_alias.value,
                name: selection.name.value
            });
        } else if (selection.kind === 'FragmentSpread') {
            // Find the fragment definition
            const fragmentDef = document.definitions.find((def)=>def.kind === 'FragmentDefinition' && 'name' in def && def.name.value === selection.name.value);
            if (fragmentDef && fragmentDef.selectionSet && fragmentDef.selectionSet.selections) {
                fragmentDef.selectionSet.selections.forEach((fragmentSelection)=>{
                    if (fragmentSelection.kind === 'Field') {
                        var _fragmentSelection_alias;
                        topLevelFields.push({
                            alias: (_fragmentSelection_alias = fragmentSelection.alias) === null || _fragmentSelection_alias === void 0 ? void 0 : _fragmentSelection_alias.value,
                            name: fragmentSelection.name.value
                        });
                    }
                });
            }
        } else if (selection.kind === 'InlineFragment' && selection.selectionSet) {
            selection.selectionSet.selections.forEach((fragmentSelection)=>{
                if (fragmentSelection.kind === 'Field') {
                    var _fragmentSelection_alias;
                    topLevelFields.push({
                        alias: (_fragmentSelection_alias = fragmentSelection.alias) === null || _fragmentSelection_alias === void 0 ? void 0 : _fragmentSelection_alias.value,
                        name: fragmentSelection.name.value
                    });
                }
            });
        }
    });
    return topLevelFields;
}

//# sourceMappingURL=extractTopLevelFieldNameData.js.map